// List of Modals to show
export const MODALS = {
  API: 'api',
  ATTRIBUTION: 'attribution',
  BASEMAPS_NO_ACCESS: 'basemapsNoAccess',
  DATE_RANGE: 'dateRange',
  ORDER: 'order',
  DOWNLOAD: 'download',
  STREAM: 'stream',
  LOGIN: 'login',
  NEWS: 'news',
  SAVE_SEARCH: 'saveSearch',
  SHARE: 'shareSession',
  SCENES_NO_ACCESS: 'scenesNoAccess',
  STORIES: 'stories',
  THANK_YOU: 'thankYou',
  TOUR: 'tour',
  OUT_OF_QUOTA: 'outOfQuota',
  DOWNLOAD_AOI: 'downloadAoi',
  UPLOAD: 'upload',
  TASKING: 'taskingRedirectDialog',
  SR_PROMPT: 'surfaceReflectancePrompt',
  TILE_USAGE: 'tileUsageDialog',
};
